import BaseRestService from './baseRestService';

const _serviceDependencies = ['$http', '$q', 'Util'];

/**
 * @ngdoc service
 * @name rest.services.AppInstanceRestService
 *
 * @description
 * This class contains methods used to retrieve/update information about app instances
 * using http requests.
 */
export default class AppInstanceRestService extends BaseRestService {

    /**
     * @param  {any} $http
     * @param  {any} $q
     * @param  {any} Util
     */
    constructor($http, $q, Util) {

        super($http, $q, Util);

    }

    /**
     * @ngdoc function
     * @name rest.services.AppInstanceRestService#create
     * @methodOf rest.services.AppInstanceRestService
     * @function
     *
     * @description
     * Creates an instance.
     *
     * @param {object} instancePayload Instance payload
     *
     * @returns {Promise} The promise of the call.
     */
    create(instancePayload) {

        return super.create(instancePayload, 'app-instances/');

    }

    /**
     * @ngdoc function
     * @name rest.services.AppInstanceRestService#update
     * @methodOf rest.services.AppInstanceRestService
     * @function
     *
     * @description
     * Updates an instance.
     *
     * @param {string} appInstanceId Instance identifier
     * @param {object} appInstancePayload Instance payload
     *
     * @returns {Promise} The promise of the call.
     */
    update(appInstanceId, appInstancePayload) {

        return super.update(appInstanceId, appInstancePayload, 'app-instances/');

    }

    /**
     * @ngdoc function
     * @name rest.services.AppInstanceRestService#remove
     * @methodOf rest.services.AppInstanceRestService
     * @function
     *
     * @description
     * Remove an instance.
     *
     * @param {number} instanceId Instance identifier
     *
     * @returns {Promise} The promise of the call.
     */
    remove(instanceId) {

        return super.remove(instanceId, 'app-instances/');

    }

    /**
     * @ngdoc function
     * @name rest.services.AppInstanceRestService#getAllAsync
     * @methodOf rest.services.AppInstanceRestService
     * @function
     *
     * @description
     * Retrieves app instances.
     *
     * @returns {Promise} The promise of the call.
     */
    getAllAsync() {

        return super.getAllAsync('app-instances/');

    }

}

_serviceDependencies.push(AppInstanceRestService);

angular.module('rest.services')
    .service('AppInstanceRestService', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/restServices/appInstanceRestService.js